<div class="warranty-settings">
  <div class="action-section flex flex-row-reverse my-[20px] w-full gap-[20px]">
    <app-primary-button (handleClick)="createWarranty()" class="!w-[150px]">Create</app-primary-button>
  </div>

  <div class="list-section">
    @if (warranties?.length) {
      <div class="warranty-list-table">
        <table [dataSource]="warranties" class="mat-elevation-z8 table" mat-table>
          <ng-container matColumnDef="name">
            <th *matHeaderCellDef mat-header-cell>
              <span class="th-text">Name</span>
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-8">{{ row?.name }}</div>
              <div class="description text-type-14">{{ row?.description }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th *matHeaderCellDef mat-header-cell>
              <span class="th-text">Status</span>
            </th>
            <td *matCellDef="let row" mat-cell>
              <div [ngClass]="statusMap[row?.status]?.textColor || ''" class="status-text text-type-11">
                {{ statusMap[row?.status]?.label || (row?.status | titlecase) }}
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="state">
            <th *matHeaderCellDef mat-header-cell>
              <span class="th-text">Milestone</span>
            </th>
            <td *matCellDef="let row" mat-cell (click)="openTasks(row, $event)" class="cursor-pointer">
              <div class="text-type-11">{{ computeWarrantyState(row)?.label || '—' }}</div>
              <app-warranty-state-diagram [warranty]="row" [compact]="true"></app-warranty-state-diagram>
            </td>
          </ng-container>

          <ng-container matColumnDef="start_date">
            <th *matHeaderCellDef mat-header-cell>
              <span class="th-text">Start Date</span>
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ row?.start_date | date:'MMM d, y' }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="end_date">
            <th *matHeaderCellDef mat-header-cell>
              <span class="th-text">End Date</span>
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ (row?.end_date || getEndDate(row)) | date:'MMM d, y' }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="duration">
            <th *matHeaderCellDef mat-header-cell>
              <span class="th-text">Duration</span>
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ row?.period_months }} months</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="contractor">
            <th *matHeaderCellDef mat-header-cell>
              <span class="th-text">Contractor</span>
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ row?.contractor?.name || '—' }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th *matHeaderCellDef mat-header-cell></th>
            <td *matCellDef="let row" mat-cell>
              <button
                mat-icon-button
                aria-label="Warranty actions"
                (click)="$event.stopPropagation()"
                [matMenuTriggerFor]="rowMenu">
                <mat-icon>more_horiz</mat-icon>
              </button>
              <mat-menu #rowMenu="matMenu">
                <button mat-menu-item (click)="openTasks(row)">
                  <mat-icon>checklist</mat-icon>
                  <span>Milestone tasks</span>
                </button>
                @if (row?.status === 'active') {
                  <button mat-menu-item (click)="closeWarranty(row)">
                    <mat-icon>lock</mat-icon>
                    <span>Close warranty</span>
                  </button>
                }
                @if (row?.status === 'closed') {
                  <button mat-menu-item (click)="reactivateWarranty(row)">
                    <mat-icon>lock_open</mat-icon>
                    <span>Reactivate warranty</span>
                  </button>
                }
                <button
                  mat-menu-item
                  [disabled]="!hasClaims(row)"
                  [matTooltip]="!hasClaims(row) ? 'No claims to export' : ''"
                  matTooltipClass="white-tooltip"
                  (click)="downloadClaimsCsv(row)">
                  <mat-icon>table_chart</mat-icon>
                  <span>Download claims (CSV)</span>
                </button>
                <button
                  mat-menu-item
                  [disabled]="!hasClaims(row)"
                  [matTooltip]="!hasClaims(row) ? 'No claims to export' : ''"
                  matTooltipClass="white-tooltip"
                  (click)="downloadClaimsPdf(row)">
                  <mat-icon>picture_as_pdf</mat-icon>
                  <span>Download claims (PDF)</span>
                </button>
                <button
                  mat-menu-item
                  [disabled]="!hasClaims(row)"
                  [matTooltip]="!hasClaims(row) ? 'No claims to export' : ''"
                  matTooltipClass="white-tooltip"
                  (click)="downloadClaimsKmz(row)">
                  <mat-icon>map</mat-icon>
                  <span>Download claims (KMZ)</span>
                </button>
                <div class="menu-divider"></div>
                <button
                  mat-menu-item
                  [disabled]="hasClaims(row)"
                  [matTooltip]="hasClaims(row) ? 'Cannot delete — warranty has claims' : ''"
                  matTooltipClass="white-tooltip"
                  (click)="deleteWarranty(row)">
                  <mat-icon>delete</mat-icon>
                  <span>Delete</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <ng-container matColumnDef="created_at">
            <th *matHeaderCellDef mat-header-cell>
              <span class="th-text">Created</span>
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ row?.created_at | date:'MMM d, y' }}</div>
            </td>
          </ng-container>

          <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
          <tr
            (click)="rowClicked(row)"
            *matRowDef="let row; columns: displayedColumns"
            [class.highlighted-row]="row === selectedRow"
            class="cursor-pointer"
            mat-row
          ></tr>
        </table>
      </div>
    } @else {
      <div class="no-data text-type-8 mt-[80px]">No warranties configured for this project.</div>
    }
  </div>
</div>
